import { Attrs, EventListeners, MinzeElement } from 'minze'
import { Font } from '../../constants'

export interface LvcToastContainer {
  dataMessage: string
  dataTimeout: number
  isError: boolean
}

export class LvcToastContainer extends MinzeElement {
  attrs: Attrs = ['data-message', 'data-timeout', ['is-error', false]]

  destroyToast = () => this.parentNode?.removeChild(this)

  onReady() {
    setTimeout(() => this.destroyToast(), this.dataTimeout)
  }

  closeToast = () => {
    this.destroyToast()
  }

  html() {
    return `
      <div id="toast-container">
      ${!this.isError ? '<lvc-toast-success-icon></lvc-toast-success-icon>' : ''}
        ${this.dataMessage}
        <button id="close-toast">
          <lvc-toast-close-icon></lvc-toast-close-icon>
        </button>
      </div>
    `
  }

  css = () => `
    #toast-container {
      z-index: 10000;
      background: ${this.isError ? '#7D001E' : '#1E007D'};
      padding: 16px;
      position: fixed;
      bottom: 20px;
      left: 20px;
      display: flex;
      gap: 16px;
      align-items: center;
      font-weight: ${Font.weight.medium};
      font-size: 14px;
      line-height: 150%;
      color: #FFFFFF;
      animation-name: appear;
      animation-duration: 0.5s;
    }
    #close-toast {
      cursor: pointer;
      background: none;
      border: none;
    }
    lvc-toast-success-icon {
      width: 32px;
      height: 32px;
    }
    lvc-toast-close-icon {
      width: 24px;
      height: 24px;
    }
    @keyframes appear {
      0%   {transform: translateX(calc(-100% - 20px))}
      100% {transform: translateX(0)}
    }
  `

  eventListeners: EventListeners = [['#close-toast', 'click', this.closeToast]]
}
